import { render, staticRenderFns } from "./focus-topics.vue?vue&type=template&id=7a768222"
import script from "./focus-topics.ts?vue&type=script&lang=ts&external"
export * from "./focus-topics.ts?vue&type=script&lang=ts&external"
import style0 from "./focus-topics.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a768222')) {
      api.createRecord('7a768222', component.options)
    } else {
      api.reload('7a768222', component.options)
    }
    module.hot.accept("./focus-topics.vue?vue&type=template&id=7a768222", function () {
      api.rerender('7a768222', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/focus-topics/focus-topics.vue"
export default component.exports